import { render, staticRenderFns } from "./logoType.vue?vue&type=template&id=7f65d8f0&scoped=true"
import script from "./logoType.vue?vue&type=script&lang=js"
export * from "./logoType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f65d8f0",
  null
  
)

export default component.exports